import { render } from "./generic.vue?vue&type=template&id=6fd40498"
import script from "./generic.vue?vue&type=script&lang=js"
export * from "./generic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__